import { StateObservable } from 'redux-observable';
import { map } from 'rxjs/operators';

import { VariablesEditorDialogAction, State } from '../..';
import { Observable } from 'rxjs';
import { EpicDependencies } from '../../dependencies.interface';
import { createSetStringEditable } from '../../actions';

export const setStringEditableFromApi = (
  _actions$: Observable<VariablesEditorDialogAction>,
  _state$: StateObservable<State>,
  dependencies: EpicDependencies,
): Observable<VariablesEditorDialogAction> => dependencies.stringEditable$.pipe(map(createSetStringEditable));
